module.exports = __webpack_public_path__ + "media/packs/user-cards/images/close-f040ea2c6fd36a31e0d023a82d43b74e.svg";